const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'mailtemplate/CREATE',
  EDIT: 'mailtemplate/EDIT'
}

export default actions
